module.exports = __webpack_public_path__ + "static/media/Restaurar Inativo.0a45fe6f.svg";